import type { ReactNode } from "react";

/**
 * Display-Schrift, tracking-display, max 3 Zeilen, links-bündig.
 * Nutzt --t-display / --t-h1 / --t-h2 / --t-h3.
 * Inline-Akzent als <em> mit --accent-blue-soft.
 */

type HeadingLevel = "display" | "h1" | "h2" | "h3";

interface HeadingProps {
  level?: HeadingLevel;
  children: ReactNode;
  /** Render-Tag override (default: h1 für display+h1, h2 für h2 etc.). */
  as?: keyof React.JSX.IntrinsicElements;
  className?: string;
}

const LEVEL_TO_FONTSIZE: Record<HeadingLevel, string> = {
  display: "var(--t-display)",
  h1: "var(--t-h1)",
  h2: "var(--t-h2)",
  h3: "var(--t-h3)",
};

const LEVEL_TO_TAG: Record<HeadingLevel, keyof React.JSX.IntrinsicElements> = {
  display: "h1",
  h1: "h1",
  h2: "h2",
  h3: "h3",
};

export function Heading({ level = "h1", children, as, className }: HeadingProps) {
  const Tag = as ?? LEVEL_TO_TAG[level];
  return (
    <Tag
      className={`beacon-heading${className ? " " + className : ""}`}
      style={{
        fontFamily: "var(--font-display)",
        fontSize: LEVEL_TO_FONTSIZE[level],
        letterSpacing: "var(--tracking-display)",
        lineHeight: 1.04,
        fontWeight: 700,
        margin: 0,
        textAlign: "left",
        textWrap: "balance",
        // colors_and_type.css setzt :where(h1) auf --fg-1 (dark blue);
        // wir overrideen mit currentColor, damit Skin-Inheritance greift.
        color: "currentColor",
      }}
    >
      {children}
    </Tag>
  );
}
